export const loadRecaptchaScript = (callback: () => void) => {
    if (window.grecaptcha) {
      console.log("reCAPTCHA already loaded");
      window.grecaptcha.ready(() => {
        callback();
      });
      return;
    }
  
    console.log("Loading reCAPTCHA script");
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit";
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      console.error("Failed to load reCAPTCHA script");
    };
    document.head.appendChild(script);
  
    // Store callbacks to handle multiple components
    const callbacks = (window as any).recaptchaCallbacks || [];
    callbacks.push(callback);
    (window as any).recaptchaCallbacks = callbacks;
  
    (window as any).onRecaptchaLoad = () => {
      console.log("reCAPTCHA script loaded globally");
      window.grecaptcha.ready(() => {
        callbacks.forEach((cb: () => void) => cb());
        (window as any).recaptchaCallbacks = []; // Clear callbacks after execution
      });
    };
  };